export const EventType = Object.freeze({
  ADMINISTRATIVE_WORK: 'administrative-work',
  CUSTOMER_VISIT: 'customer-visit',
  PROSPECTION: 'prospection',
});

export const EventStatus = Object.freeze({
  PLANNED: 'planned',
  UNPLANNED: 'unplanned',
  OVERDUE: 'overdue',
  PENDING: 'pending',
});

export const EventConfirmationStatus = Object.freeze({
  CONFIRMED: 'confirmed',
  NOT_CONFIRMED: 'not-confirmed',
});

export const EventStatusColor = Object.freeze({
  PLANNED: '#1BA13C',
  UNPLANNED: '#AF64FD',
  OVERDUE: '#E7090A',
  PENDING: '#F5A623',
  DEFAULT: '#9E9E9E',
});

export const EventKind = Object.freeze({
  SINGLE: 'single',
  TEMPLATE: 'template',
  OCCURRENCE: 'occurrence',
  OCCURRENCE_MATERIALIZED: 'occurrence-materialized',
});

export const EventAction = Object.freeze({
  RESCHEDULE: 'reschedule',
  UPDATE_RECURRENCE: 'update-recurrence',
  CONFIRM_EVENT: 'confirm-event',
  CONFIRM_ACTIVITIES: 'confirm-activities',
});
